import { Image } from '@ui/atoms';
import BackgroundCircles from '@components/Products/FixedDeposits/components/HeroSection/BackgroundCircles';
import HeroContent from '@components/Products/FixedDeposits/components/HeroSection/HeroContent';

const FixedDepositsHero = ({ toggleModal, maxInterest }) => {
    return (
        <section className="p-4 md:p-6">
            <div className="relative flex items-center justify-center overflow-hidden bg-primary-500 max-w-[1232px] mx-auto rounded-3xl h-auto min-h-[509px] md:h-[538px] p-4">
                <BackgroundCircles />
                <Image
                    src="/images/products/fd-banner-gradient.svg"
                    className="absolute top-0"
                />
                <HeroContent toggleModal={toggleModal} maxInterest={maxInterest} />
            </div>
        </section>
    );
};

export default FixedDepositsHero;
